import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import {
  StyledDialog,
  Content,
  CloseIconStyled,
  CloseBox,
  Icon,
  BoxButton,
  InfoBox,
  InfoIconStyled,
} from './styles';
import { HeadlineLarge } from 'v3/shared/typography/HeadlineLarge';
import { useTheme } from '@mui/material/styles';
import { ISuccessfulPaymentModal } from 'v3/shared/components/Modal/SuccessfulPaymentModal/types';
import check from 'assets/icons/check.svg';
import { TitleSmall } from 'v3/shared/typography/TitleSmall';

export const SuccessfulPaymentModal: React.FC<ISuccessfulPaymentModal> = ({ open, setOpenModal }) => {
  const theme = useTheme();

  return (
    <StyledDialog open={open}>
      <CloseBox>
        <CloseIconStyled onClick={() => setOpenModal()} aria-label="Fechar modal" />
      </CloseBox>
      <Content>
        <Icon src={check} alt="Check" />
        <HeadlineLarge color={theme.palette.common.white} align='center'>Seu pagamento pelo PIX foi recebido</HeadlineLarge>
        <InfoBox>
          <InfoIconStyled />
          <TitleSmall color={theme.palette.common.black}>O celular do seu cliente pode levar até 5 minutos para desbloquear após o pagamento</TitleSmall>
        </InfoBox>
        <BoxButton>
          <FlexButton
            text="Certo, entendi"
            size="small"
            handleClick={() => setOpenModal()}
          />
        </BoxButton>
      </Content>
    </StyledDialog>
  );
};